<template>
  <div ref="widgetContainer">
    <Row class="widget-container">
      <Card class="widget-height-md ivu-card-custom" border stripe shadow>
        <div slot="title" class="with-icon">
          <h4>Export to Excel</h4>
        </div>
        <div class="widget-data full-height p-3">
          <Row>
            <i-col :xs="12" :sm="12" :md="12" :lg="12" align="left">
              <Button class="btn btn-excel" size="large" @click="exportXLSX" :disabled="disableExport">
                <Icon type="ios-document-outline" size="25"></Icon>
                Save As xlsx
              </Button>
              <exportForm ref="exportForm"></exportForm>
            </i-col>
            <i-col :xs="12" :sm="12" :md="12" :lg="12" align="left">
              <Button class="btn btn-primary" size="large" @click="openExport" :disabled="disableExport">
                <Icon type="ios-mail-outline" size="25"></Icon>
                Send Xlsx As E-Mail
              </Button>
            </i-col>
          </Row>
          <Spin size="large" fix v-if="spinShow">Loading...</Spin>
        </div>
      </Card>
    </Row>
  </div>
</template>

<script>
  import {exportLeadFile} from '../../services/LeadForms.service'
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../../main'
  import exportForm from './exportForm'

  export default {
    components: {
      exportForm
    },
    data() {
      return {
        disableExport: true,
        spinShow: false,
        questionsAnswers: [{
          questionId: null,
          question: null,
          answer: null,
        }],
        items: [],
        tableWidth: 0,
        dataColumns: [],
        dataCount: 0,
        pageSizer: [10, 25, 50, 100],
        pageSize: 10,
        historyData: [],
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      openExport() {
        this.$refs.exportForm.openExportForm();
        this.$refs.exportForm.setFormValue();
      },

      exportXLSX() {
        this.spinShow = true;
        let localCompany = localStorage.getItem('selected_company');
        let localEvent = localStorage.getItem('selected_event');

        let company = JSON.parse(localStorage.getItem('companies'))
          .filter(a => a.companyName === localCompany || a.companyId === parseInt(localCompany))[0];

        let event = JSON.parse(localStorage.getItem('events'))
          .filter(a => a.eventName === localEvent || a.eventId === parseInt(localEvent))[0];

        const self = this;
        let companyId = null;
        let eventId = 0;
        if (company && event) {
          companyId = company.companyId;
          eventId = event.eventId;
          exportLeadFile(companyId, eventId)
            .then(response => {
              self.items = [];
              self.tableWidth = 0;
              self.dataColumns = [];
              self.dataCount = 0;
              self.pageSizer = [10, 25, 50, 100];
              self.pageSize = 10;
              self.historyData = [];
              self.spinShow = true;
              self.disableExport = true;
              if (response.data.value) {
                let FileSaver = require('file-saver');
                downloadFile(response.data.value);

                function downloadFile(blobContent) {
                  let blob = new Blob([base64toBlob(blobContent, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')], {});
                  FileSaver.saveAs(blob, 'report.xlsx');
                }

                function base64toBlob(base64Data, contentType) {
                  contentType = contentType || '';
                  let sliceSize = 1024;
                  let byteCharacters = atob(base64Data);
                  let bytesLength = byteCharacters.length;
                  let slicesCount = Math.ceil(bytesLength / sliceSize);
                  let byteArrays = new Array(slicesCount);
                  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                    let begin = sliceIndex * sliceSize;
                    let end = Math.min(begin + sliceSize, bytesLength);

                    let bytes = new Array(end - begin);
                    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                      bytes[i] = byteCharacters[offset].charCodeAt(0);
                    }
                    byteArrays[sliceIndex] = new Uint8Array(bytes);
                  }
                  return new Blob(byteArrays, {type: contentType});
                }
              } else {
                this.$Message.error('No Participants found!')
              }

              setTimeout(function () {
                self.tableWidth = 0;
                self.dataColumns = [];
                self.dataCount = 0;
                self.pageSizer = [10, 25, 50, 100];
                self.pageSize = 10;
                self.historyData = [];
                self.spinShow = false;
                self.disableExport = false;
              }, 500);
            })
            .catch(error => {
              if(error.response.status == 404)
                this.$Message.error('No lead form to export!')
              console.log(error);
              setTimeout(function () {
                self.tableWidth = 0;
                self.dataColumns = [];
                self.dataCount = 0;
                self.pageSizer = [10, 25, 50, 100];
                self.pageSize = 10;
                self.historyData = [];
                self.spinShow = false;
                self.disableExport = false;
              }, 500);
            })
        } else {
          self.items = [];
          self.tableWidth = 0;
          self.dataColumns = [];
          self.dataCount = 0;
          self.pageSizer = [10, 25, 50, 100];
          self.pageSize = 10;
          self.historyData = [];
          self.spinShow = false;
          self.disableExport = true;
        }
      },

      changePageSize(size) {
        this.pageSize = size;
        this.changeSelectedPage(1);
      },

      changeSelectedPage(index) {
        let _start = (index - 1) * this.pageSize;
        let _end = index * this.pageSize;
        this.items = this.historyData.slice(_start, _end);
      },

    },

    created() {
    },

    mounted() {
      let localCompany = localStorage.getItem('selected_company');
      let localEvent = localStorage.getItem('selected_event');

      let company = JSON.parse(localStorage.getItem('companies'))
        .filter(a => a.companyName === localCompany || a.companyId === parseInt(localCompany))[0];

      let event = JSON.parse(localStorage.getItem('events'))
        .filter(a => a.eventName === localEvent || a.eventId === parseInt(localEvent))[0];

      if (event && company) {
        this.disableExport = false;
      } else {
        this.disableExport = true;
      }

      bus.$on('changeForm', (eventName, companyName) => {
        this.items = [];
        if (eventName && companyName) {
          this.disableExport = false;
        } else {
          this.disableExport = true;
        }
      });
      bus.$on('changeExportDataForm', (eventName, companyName) => {
        this.items = [];
        if (eventName && companyName) {
          this.disableExport = false;
        } else {
          this.disableExport = true;
        }
      });
      document.getElementsByClassName('ivu-card-body')[0].style.minHeight = '10px';
    }
  }
</script>

<style scoped>
  .ivu-card-custom {
    overflow: hidden;
    height: auto;
  }

  .ivu-table table tbody tr td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table-wrapper:not(.show-borders) .ivu-table table tbody tr:last-of-type td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table td {
    height: 80px;
  }

  .ivu-table .table-cell-custom {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ivu-table-cell .ivu-poptip,
  .ivu-table-cell .ivu-table-sort {
    position: absolute;
    right: auto;
  }

  .ivu-table-cell td, .ivu-table-cell th {
    border: 0;
    height: 20px;
    line-height: 1;
    overflow: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/components/f_ExportData/ExportData.vue